import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FormBuilderService {

  private formValueSubject = new BehaviorSubject<any>({});
  public obvStep: Observable<any> = this.formValueSubject.asObservable(); // convert to Observable for subscribing

  constructor() {
  }

  setForm(value: any) {
    this.formValueSubject.next(value);
  }

  getForm(): Observable<any> {
    return this.obvStep;
  }

}
